/* eslint-disable no-use-before-define, default-param-last */
import { point } from '@turf/helpers';
import { Marker, Popup } from 'mapbox-gl';
import { createMarkerPin } from './utility';
import Events from './events';

export default class mapMarker {
  #marker;
  #pinElement;
  id;
  point;
  distanceFromUser;

  constructor(data) {
    this.#pinElement = createMarkerPin(data.icon);
    this.#marker = this.createMapboxMarker(data);
    this.id = data.id;
    this.point = this.#createPoint();

    this.mount();
  }

  attachListeners() {
    this.on('click', () => {
      window.dispatchEvent(Events.MarkerClicked(this));
    });
  }

  on(event = 'click', fn) {
    this.#marker.getElement().addEventListener(event, (e) => fn(e));
  }

  remove() {
    this.#marker.remove();
  }

  coordinates() {
    return this.#marker.getLngLat();
  }

  popup() {
    return this.#marker.getPopup();
  }

  togglePopup() {
    this.#marker.togglePopup();
  }

  openPopup() {
    if (this.popupIsOpen()) return;

    this.togglePopup();
  }

  closePopup() {
    if (!this.popupIsOpen()) return;

    this.togglePopup();
  }

  popupIsOpen() {
    return this.popup().isOpen();
  }

  addTo(map) {
    this.#marker.addTo(map);
  }

  #createPoint() {
    const { lat, lng } = this.coordinates();

    return point([lng, lat]);
  }

  #createPopup(html) {
    // Fixes bug where whole page would scroll when switching between popups
    // Solution found here: https://github.com/mapbox/mapbox-gl-js/issues/10329
    const focusAfterOpen = false;

    const options = {
      offset: 38,
      anchor: 'bottom',
      focusAfterOpen,
    };

    return new Popup(options).setHTML(html);
  }

  createMapboxMarker(data) {
    const popupHtml = data.popup;
    const popup = popupHtml ? this.#createPopup(popupHtml) : null;

    const markerOptions = {
      element: this.#pinElement,
      anchor: data.icon !== 'userIcon' ? 'bottom' : 'center',
    };

    return new Marker(markerOptions)
      .setLngLat([data.longitude, data.latitude])
      .setPopup(popup);
  }

  mount() {
    this.attachListeners();
  }
}
